import { http } from "@/libs/func";


// 刷新token
export const refreshToken = (data:any) => http.post('/bus/refresh-token',data)

// 登录
export const login = (data?:any) => http.post('/bus/login',data)

// 获取微信登录二维码
export const getWxqrcode = (data?:any) => http.post('/bus/generate-wxqrcode',data)


// 微信扫码注册，获取微信信息
export const getWxinfo = (data?:any) => http.get('/bus/get-wxinfo',data)

// 注册
export const register = (data:any) => http.post('/bus/register',data)

// 修改密码
export const changePassword = (data:any) => http.post('/bus/change-password',data)

// 重置密码
export const resetPassword = (data:any) => http.post('/bus/reset-password',data)

// 获取验证码
export const sendCode = (data:any) => http.post('/bus/send-sms-code',data)

// 验证手机号
export const checkPhone = (data:any) => http.post('/bus/check-phone-exist',data)

// 校验验证码
export const verifyCode = (data:any) => http.post('/bus/verify-phone-code',data)


// 校验图形验证码
export const verifyCaptcha = (data:any) => http.post('/bus/verify-code-captcha',data)


// 微信登录
export const wxLoginbyCode = (data:any) => http.post('/bus/login-by-wxcode',data)


// 绑定微信 
export const bindwx = (data:any) => http.post('/bus/bindwx',data)

// 解除绑定微信 
export const unbindwx = (data?:any) => http.post('/bus/unbindwx',data)



// 员工列表
export const userList = (data?:any,options?: any) => http.get('/bus/userlist',data)

// 启用禁用删除员工
export const updateUserState = (data:any) => http.post('/bus/update-user-state',data)

// 添加修改员工
export const editUser = (data:any) => http.post('/bus/edit-user',data)

// 权限列表
export const userRoleList = () => http.get('/bus/menulist')

// 业务员
export const userListPure = () => http.get('/bus/userlist-pure')
